import { isValidIconValue, getIconArray } from '../icon-control'
import classnames from 'classnames'

const IconDisplay = props => {
    const {
        value, size, additionalClass 
    } = props
    const selectedIcon = getIconArray( value )
    const isValidIcon = isValidIconValue( value )

    const prefix = isValidIcon && selectedIcon[0][0]

    const iconClassNames = ( isValidIcon && selectedIcon ) && classnames( [
        prefix === 'czi' && `${prefix} czi-${selectedIcon[1]}`,
        prefix !== 'czi' && `${prefix} fa-${selectedIcon[1]}`,
        size,
        additionalClass
    ] )

    const iconComp = <i className={ iconClassNames }></i>

    return iconComp
}

export default IconDisplay